import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {type VersionInfo, fetchVersionInfo} from '../libs/version';

export type VersionState = {
  data: VersionInfo | undefined;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error?: string;
};

const initialState: VersionState = {
  data: undefined,
  status: 'idle',
};

export const loadVersionInfo = createAsyncThunk('version/load', async () =>
  fetchVersionInfo(),
);

const versionSlice = createSlice({
  name: 'version',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(loadVersionInfo.pending, state => {
        state.status = 'loading';
        state.error = undefined;
      })
      .addCase(loadVersionInfo.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(loadVersionInfo.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default versionSlice.reducer;
